import React from "react";
import { Settings } from "../components/Settings/Settings";
import { Page } from "../components/Page/Page";
import "./PageLayout.css";

export function SettingsPage() {
  return (
    <Page>
      <div className="page-layout">
        <div className="page-content">
          <Settings />
        </div>
      </div>
    </Page>
  );
}
